<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import ThuxGenericComponentFilterMixin from '../../../components/thux-list/ThuxGenericComponentFilterMixin'
import { CommonFilterTypes } from '../store'

export default {
  name: 'OrganizationListFilter',
  mixins: [ThuxGenericComponentFilterMixin],
  props: {
    onlyActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icon: 'far fa-building',
      itemName: 'organization',
      itemPluralName: 'organizations',
      placeholder: 'Type an organization',
      filterName: 'filter__name__icontains',
      searchLength: 2
    }
  },
  computed: {
    ...mapGetters({
      list: CommonFilterTypes.COMMON_FILTERS.ORGANIZATION_COMMON_FILTER.LIST.GETTERS.list
    })
  },
  methods: {
    ...mapMutations({
      setList:
        CommonFilterTypes.COMMON_FILTERS.ORGANIZATION_COMMON_FILTER.LIST.MUTATIONS.setList
    }),
    ...mapActions({
      ...CommonFilterTypes.COMMON_FILTERS.ORGANIZATION_COMMON_FILTER.LIST.ACTIONS
    }),
    getComponentFilter () {
      this.setList({})
    },
    onSearchItem (search) {
      this.$store.commit('componentLoading', false)
      if (search.length >= this.searchLength) {
        const filters = {}
        filters[this.filterName] = search
        if (this.onlyActive) filters.only_active = true
        filters.order_by = '-status.-date_create'
        this.setFilters(filters).then(() => {
          this.$store.commit('componentLoading', true)
        })
      } else {
        this.setList({})
        this.$store.commit('componentLoading', true)
      }
    }
  }
}
</script>
